export default "__VITE_ASSET___tmjpAGD__"